import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { privateData } from '../../config/apiKey';
import { xSignature } from '../../config/x-signature';
import { isLoggedIn } from '../../utils/LoggedIn';

// const apiUrl = 'https://api.example.com/cities';

export const postConfirmBooking = createAsyncThunk('confirmBooking/postConfirmBooking', async (payload) => {
  console.log('payload===>', payload)
  //{{loc}}/api/v1/user//hotel/booking?cartId=65d2f16ea1b8c4db9a60e478
  const response = await axios.post(`https://swtclub.com:4300/api/v1/user/hotel/booking`, payload, {
    headers: {
      "Authorization": isLoggedIn("swtadmin")
    },
  });
  return response.data;
});



export const faqAction = createAsyncThunk('faq/faqAction', async (payload) => {
  console.log('payload===>', payload)
  //{{loc}}/api/v1/user//hotel/booking?cartId=65d2f16ea1b8c4db9a60e478
  const response = await axios.get(`https://swtclub.com:4300/api/v1/user/faq/faq-list`, {
    headers: {
      "Authorization": isLoggedIn("swtadmin")
    },
  });
  return response.data;
});